import { useAppState } from '../core/redux/hooks';


/**
 * Returns the current user if one is signed in
 */
export const useCurrentUser = () => useAppState(state => state.auth?.currentUser);

/**
 * Returns the current portal space, if we are currently in one
 */
export const usePortalType = () => useAppState(state => state.portalType);
